import './App.css';
import { Home } from './components/Home/Home.js'
import { Navbar } from './components/Navbar/Navbar.js';
import { Projects } from './components/Projects/Projects.js';
import { PrivacyPolicyPage } from './components/Projects/PrivacyPolicyPage.js';
import { FAQPage } from './components/Projects/FAQPage.js';
import {mealvaultFAQs} from './components/Projects/MealVaultFAQ.js'

import { HashRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/projects/privacy/:appName" element={<PrivacyPolicyPage />}/>
          <Route path="/projects/support/:appName" element={<FAQPage  faqs={mealvaultFAQs}/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
